import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  id: "marker-icon",
  fill: "none",
  role: "img",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M12.7917 13V13C11.1347 13 9.79169 11.657 9.79169 10V10C9.79169 8.343 11.1347 7 12.7917 7V7C14.4487 7 15.7917 8.343 15.7917 10V10C15.7917 11.657 14.4487 13 12.7917 13Z",
      stroke: "currentColor",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1),
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M12.7917 21C12.7917 21 5.79169 15.25 5.79169 10C5.79169 6.134 8.92569 3 12.7917 3C16.6577 3 19.7917 6.134 19.7917 10C19.7917 15.25 12.7917 21 12.7917 21Z",
      stroke: "currentColor",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1)
  ])))
}
export default { render: render }